import { CounselingPageComponent } from './counseling-page/counseling-page.component';

export const COUNSELING_PAGES = [CounselingPageComponent];
